import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { FormControl, FormGroup } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { PdfChart } from '../../shared/pdfChart'
import { ActivatedRoute } from '@angular/router'
import { ExportPPTService } from 'app/service/export-ppt.service'
import 'rxjs/add/operator/map'
@Component({
  selector: 'app-capital-raised-ipo-so',
  templateUrl: './capital-raised-ipo-so.component.html',
  styleUrls: ['./capital-raised-ipo-so.component.scss']
})
export class CapitalRaisedIpoSoComponent implements OnInit, OnDestroy, AfterViewInit {
  tradingDate
  dataChart2
  dataExcel
  chart2
  getPrint
  textMark
  form: FormGroup
  capitalList
  capitalHeader
  capitalSecurities
  capitalIpovalue
  capitalIpochange
  capitalSovalue
  capitalSochange
  dataProvider
  endYear = new Date().getFullYear()
  pdfChart: PdfChart = new PdfChart()
  radios = [
    { value: 'M', des: 'Market cap' },
    { value: 'C', des: 'Capital raised' }
  ]
  currentItem = 'M'

  constructor(
    private amCharts: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private pptService: ExportPPTService
  ) { }

  ngOnInit() {
    this.getLastTradingDate().then(endYear =>
      this.loadDataFromGetLastTradingDate(endYear)
    )

    const { print } = this.activatedRoute.snapshot.data
    const { ytdValue2 } = this.activatedRoute.snapshot.params
    const { pdf } = this.activatedRoute.snapshot.data

    this.getPrint = print

    this.pdfChart.setPdf(pdf)
    ytdValue2 === undefined
      ? (this.currentItem = 'M')
      : (this.currentItem = ytdValue2)

    this.form = new FormGroup({
      radioValue: new FormControl(this.currentItem)
    })

    this.onChangeData()
  }

  loadDataFromGetLastTradingDate(endYear) {
    this.endYear = endYear
    const startYear = this.endYear - 4

    const dataProvider = []
    this.cpmService
      .getCapitalRaisediposo(
        this.form.get('radioValue').value,
        startYear,
        this.endYear
      )
      .subscribe(obj => {
        this.capitalList = obj
        this.capitalHeader = obj.map(header => header.year)
        this.capitalSecurities = obj.map(ipoSec => ipoSec.ipoSecurities)
        this.capitalIpovalue = obj.map(ipoVal => Math.round(ipoVal.ipoValue))
        this.capitalIpochange = obj.map(ipoCha => ipoCha.ipoChange ? ipoCha.ipoChange.toFixed(2) : null)
        this.capitalSovalue = obj.map(soVal => Math.round(soVal.soValue))
        this.capitalSochange = obj.map(soCha => soCha.soChange ? soCha.soChange.toFixed(2) : null)
        const data = []
        data.push(...obj)
        this.dataProvider = data

        this.dataChart2 = this.markChart1()
        this.chart2 = this.amCharts.makeChart('chart2div', this.dataChart2)
      })
  }

  markChart1() {
    const startYear = this.endYear - 4
    const dataChart = {
      type: 'serial',
      theme: 'none',
      color: 'black',
      fontFamily: 'browallia',
      fontSize: 18,
      addClassNames: true,
      legend: {
        enabled: true,
        position: 'bottom',
        useGraphSettings: true,
        align: 'center'
      },
      dataProvider: this.dataProvider,

      valueAxes: [
        {
          id: 'ValueAxis-1',
          stackType: 'regular',
          title: this.textMark + ' (M.Baht)'
        },
        {
          id: 'ValueAxis-2',
          position: 'right',
          title: 'Year'
        }
      ],
      graphs: [
        {
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0,
          title: 'IPO',
          type: 'column',
          color: '#fff',
          fillColors: '#ffa400',
          valueField: 'ipoValue'
        },
        {
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            const year = graphDataItem.category;
            const title = graph.title;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '<b>' + title + '</b><br><span style="font-size:14px">'
              + year + ': <b>' + value + '</b></span>';
          },
          labelFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value;
            value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return value;
          },
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0,
          title: 'SO',
          type: 'column',
          color: '#fff',
          fillColors: '#5f6062',
          valueField: 'soValue'
        }
      ],
      categoryField: 'year',
      categoryAxis: {
        gridPosition: 'start',
        title: 'Year'
      },
      export: {
        enabled: false,
        menu: [
          {
            class: 'export-main',
            menu: [
              {
                format: 'PDF',
                fileName: 'Capital raised by IPO and SO',
                content: [{ image: 'reference', fit: [523.28, 769.89] }]
              }
            ]
          }
        ]
      },
      titles: [
        {
          id: 'Title-1',
          size: 20,
          text: 'Capital raised by IPO and SO'
        }
      ]
    }

    return dataChart
  }

  onChangeData() {
    const startYear = this.endYear - 4
    const xx = []
    if (this.currentItem === 'M') {
      this.textMark = 'Market cap'
    } else {
      this.textMark = 'Capital raised'
    }

    this.cpmService
      .getCapitalRaisediposo(
        this.form.get('radioValue').value,
        startYear,
        this.endYear
      )
      .subscribe(obj => {
        this.capitalList = obj
        this.capitalHeader = obj.map(header => header.year)
        this.capitalHeader.sort()
        this.capitalSecurities = obj.map(ipoSec => ipoSec.ipoSecurities)
        this.capitalIpovalue = obj.map(ipoVal => ipoVal.ipoValue)
        this.capitalIpochange = obj.map(ipoCha => ipoCha.ipoChange ? ipoCha.ipoChange.toFixed(2) : null)
        this.capitalSovalue = obj.map(soVal => soVal.soValue)
        this.capitalSochange = obj.map(soCha => soCha.soChange ? soCha.soChange.toFixed(2) : null)

        const data = []
        data.push(...obj)
        this.dataProvider = data

        this.dataChart2 = this.markChart1()
        this.chart2 = this.amCharts.makeChart('chart2div', this.dataChart2)
      })
  }

  ngOnDestroy() {
    if (this.chart2 && this.chart2.legend && this.chart2.legend.destroy) {
      if (this.chart2 != null) {
        this.amCharts.destroyChart(this.chart2)
      }
    }
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

  Ppt() {
    this.pptService.pptCapitalRaisedByIPOandSO(
      this.capitalHeader,
      this.capitalIpovalue,
      this.capitalSovalue,
      this.capitalSecurities,
      this.capitalIpochange,
      this.capitalSochange,
      this.textMark
    )
  }

  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }

  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'indexNegative' : ''
  }


}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/capital-raised-ipo-so/capital-raised-ipo-so.component.ts